






import { Vue, Component, Prop } from "@/shared/vuepack";
import SharedPartnerUsers from "@/shared/components/partners/PartnerUsers.vue";

@Component ({
  components: {
    SharedPartnerUsers
  }
})
export default class PartnerUsers extends Vue {
  @Prop() partnerId: number;

  @Prop() userPageNumber: number;
}
